/**
 * Utility สำหรับเข้ารหัส/ถอดรหัสแบบ AES
 * ใช้สำหรับ encrypt password ก่อนส่งไป backend และ backend สามารถ decrypt ได้
 */
import CryptoJS from 'crypto-js'

/**
 * เข้ารหัสข้อความด้วย AES
 * @param plainText ข้อความที่ต้องการเข้ารหัส
 * @param key คีย์สำหรับเข้ารหัส (ต้องใช้คีย์เดียวกันทั้งหน้าบ้านและหลังบ้าน)
 * @returns ข้อความที่เข้ารหัสแล้ว (Base64)
 */
export const encrypt = (plainText: string, key: string): string => {
  // console.log('plainText', plainText)
  // console.log('key', key)
  const encrypted = CryptoJS.AES.encrypt(plainText, key).toString()
  //console.log('encrypted', encrypted)
  const decrypted = decrypt(encrypted, key)
  //console.log('decrypted', decrypted)
  return encrypted
}

/**
 * ถอดรหัสข้อความที่เข้ารหัสด้วย AES
 * @param encryptedText ข้อความที่เข้ารหัสแล้ว
 * @param key คีย์สำหรับถอดรหัส (ต้องใช้คีย์เดียวกันกับตอนเข้ารหัส)
 * @returns ข้อความต้นฉบับ
 */
export const decrypt = (encryptedText: string, key: string): string => {
  const bytes = CryptoJS.AES.decrypt(encryptedText, key)
  const decrypted = bytes.toString(CryptoJS.enc.Utf8)
  return decrypted
}
